module.exports = __webpack_public_path__ + "img/shhg.62d6b554.png";